import { createContext, useContext, useEffect, useState } from "react";
import { auth } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  // null = checking, false = anonymous, object = authenticated
  const [user, setUser] = useState(null);

  useEffect(() => {
    let cancelled = false;
    if (!auth.getToken()) {
      setUser(false);
      return;
    }
    auth.me()
      .then((u) => { if (!cancelled) setUser(u); })
      .catch(() => { if (!cancelled) setUser(false); });
    return () => { cancelled = true; };
  }, []);

  async function login(email, password) {
    const u = await auth.login(email, password);
    setUser(u);
    return u;
  }
  async function logout() {
    await auth.logout();
    setUser(false);
  }

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}
